export default {
	props:{
		name: String,
		value: [String, Number],
		type: {
			type: String,
			default: 'text',
		},
		autocomplete: String,
		extLabel: String, //work as label
		label: String, //work as placeholder
		clearable: Boolean,
		disabled: Boolean,
		errorMsg: String,
	},
	data(){
		return {
			innerValue: null,
			hintVisible: true,
		}
	},
	watch: {
		value:{
			immediate: true,
			handler(){ this.innerValue = this.value;},
		},
		innerValue:{
			immediate: true,
			handler(){
				//this.hintVisible = !this.innerValue;
				this.$emit('input', this.innerValue);
				this.$emit('change', this.innerValue);
			},
		},
	},
	computed:{
		//
	},
	methods: {
		focus(){
			this.$refs.inputElement.focus();
		},
		blur(){
			this.$refs.inputElement.blur();
		},
		onClear(){
			this.innerValue = '';
			this.$emit('clear');
		},
	},
	template: `
<div :class="['styled-input', 'input-'+type, type==='radio'||type==='checkbox'?'h-auto':'', clearable?'clearable':'']">
	<label v-if="extLabel" class="ext-label" :for="name">{{extLabel}}</label>
	<template v-if="type==='textarea'">
		<textarea ref="inputElement" :id="name" :name="name" :placeholder="label" v-model="innerValue" :autocomplete="autocomplete" @focus="$emit('focus')" @blur="$emit('blur')"></textarea>
	</template>
	<template v-else>
		<input ref="inputElement" :id="name" :name="name" :type="type" :placeholder="label" v-model="innerValue" :autocomplete="autocomplete" @focus="$emit('focus')" @blur="$emit('blur')" />
	</template>
	<span v-if="hintVisible && errorMsg" class="hint error-msg" v-t="errorMsg"></span>
	<span v-if="clearable && innerValue" class="clear-btn" @click="onClear"></span>
</div>
`,
}
